import React, { useContext, useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import {
  Form,
  Table,
  Pagination,
  Offcanvas,
  Button,
  Row,
  Col,
} from "react-bootstrap";
import { FaPlus } from "react-icons/fa";
import DeleteModal from "../../components/common/DeleteModel";
import useMenuPermissions from "../../components/CustomHook/custompermission";
import Notauthorized from "../../components/Not-authorized/notauthorized";
import { UserContext } from "../../context/UserContextProvider";
import APIServicenew from "../../utils/APIGeneralService";
import Paginator from "../../components/common/Pagination";
import { formatDateTime } from "../../utils/Helper";
import { ToastContainer, toast } from "react-toastify";
import { capitalizeFirstLetter } from "../../utils/Helper";

const MemberList = () => {
  const navigate = useNavigate();
  const permissionscontext = useMenuPermissions("/admin/members");
  const APIServices = new APIServicenew(process.env.REACT_APP_OTHER_API_URL);
  const authToken = process.env.REACT_APP_authToken;
  const { accessToken, logout } = useContext(UserContext);
  const headers = { "auth-token": authToken, authorization: accessToken };
  const limit = 10;
  const [show, setShow] = useState(false);
  const [dataList, setDataList] = useState([]);
  const [count, setCount] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [showDt, setShowDt] = useState(false);
  const [selectedId, setSelectedId] = useState("");
  const [searchTerm, setSearchTerm] = useState({
    name: "",
    email: "",
    status: "",
    phone: "",
    role_id: "",
    region_id: "",
    state_id: "",
    city_id: "",
  });
  const [filterOptions, setFilterOptions] = useState({
    roles: [],
    regions: [],
    cities: [],
    states: [],
  });
  const [flag, setFlag] = useState(false);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };
  useEffect(() => {
    fetchFilterOptions();
  }, []);

  const fetchFilterOptions = async () => {
    try {
      const [roles, regions,] = await Promise.all([
        APIServices.get(`/admin/auth/role_list?system_role=1`, headers),
        APIServices.get(`/admin/cms/region_list/${"101"}`, headers),
      ]);

      setFilterOptions({
        roles: roles?.data?.list || [],
        regions: regions?.data?.list || [],
      });
    } catch (error) {
      console.error("Error fetching filter data:", error);
    }
  };

  const fetchStates = async (regionId) => {
    try {
      const response = await APIServices.get(
        `/admin/cms/state_list/${regionId}`,
        headers
      );
      if (response?.status === 200) {
        const stateList = response?.data?.list || [];
        setFilterOptions((pre) => ({ ...pre, states: stateList }));
      } else if (response?.status === 401) {
        logout();
        navigate("/");
      } else {
        setFilterOptions((pre) => ({ ...pre, states: [] }));
      }
    } catch (error) {
      console.error("Error fetching states:", error);
    }
  };

  const fetchCities = async (stateId) => {
    try {
      const response = await APIServices.get(
        `/admin/cms/city_list/${stateId}`,
        headers
      );
      if (response?.status === 200) {
        const citiesList = response?.data?.list || [];
        setFilterOptions((pre) => ({ ...pre, cities: citiesList }));
      } else if (response?.status === 401) {
        logout();
        navigate("/");
      } else {
        setFilterOptions((pre) => ({ ...pre, cities: [] }));
      }
    } catch (error) {
      console.error("Error fetching cities:", error);
    }
  };

  useEffect(() => {
    fetchData(currentPage);
  }, [currentPage, flag]);

  const fetchData = async (page = 1) => {
    const skip = (page - 1) * limit;

    try {
      const response = await APIServices.get(
        `/admin/member/list?offset=${skip}&limit=${limit}&status=${searchTerm.status}&name=${searchTerm.name}&email=${searchTerm.email}&user_type=${searchTerm.role_id}&mobile=${searchTerm.phone}&region_id=${searchTerm.region_id}&state_id=${searchTerm.state_id}&city_id=${searchTerm.city_id}`,
        headers
      );
      if (response?.status === 200) {
        const data1 = response?.data?.list || [];
        setDataList(data1);
        setCount(response?.data?.count);
        const totalItems = response?.data?.count || 0;
        setTotalCount(Math.ceil(totalItems / limit));
        setShow(false);
        setFlag(false);
      } else if (response?.status === 401) {
        logout();
        navigate("/");
      } else {
        setDataList([]);
        setTotalCount(0);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setDataList([]);
      setTotalCount(0);
    }
  };
  const handleStatusChange = async (it) => {
    const newStatus = it.status === "Active" ? "Inactive" : "Active";
    try {
      const payload = { id: it.id, status: newStatus };
      const res = await APIServices.post(
        `/admin/member/status_update`,
        payload,
        headers
      );
      if (res?.data?.status === true) {
        showToast(res?.data?.message || "Success", "success");
        const updatedFaqs = dataList.map((item) =>
          item.id === it.id ? { ...item, status: newStatus } : item
        );
        setDataList(updatedFaqs);
      } else {
        showToast(res?.data?.message || "Something went wrong.", "error");
      }
    } catch (error) {
      console.error("Error updating status:", error);
      showToast("Error updating status", "error");
    }
  };
  const handleDelete = async () => {
    try {
      if (selectedId !== null) {
        const payload = { id: selectedId };
        const res = await APIServices.post(
          `/admin/member/delete`,
          payload,
          headers
        );
        if (res?.data?.status === true) {
          showToast(res?.data?.message || "Success", "success");
          const updatedFaqs = dataList.filter((faq) => faq.id !== selectedId);
          setDataList(updatedFaqs);
          setSelectedId(null);
        } else {
          showToast(res?.data?.message || "Something went wrong.", "error");
        }
      }
      setShowDt(false);
    } catch (error) {
      console.error("Error deleting FAQ:", error);
    }
  };

  const handleSearchChange = (event) => {
    const { name, value } = event.target;

    setSearchTerm({ ...searchTerm, [name]: value });

    if (name === "region_id") {
      fetchStates(value);
    }
    if (name === "state_id") {
      fetchCities(value);
    }
  };

  const resetDta = () => {
    setSearchTerm({
      name: "",
      email: "",
      status: "",
      phone: "",
      role_id: "",
      region_id: "",
      state_id: "",
      city_id: "",
    });
    setShow(false);
  };
  const showToast = (message, type) => {
    toast(message, {
      position: "top-right",
      autoClose: 2000,
      type,
      hideProgressBar: false,
      closeOnClick: true,
    });
  };
  return (
    <>
      {permissionscontext.view ? (
        <>
          <div className="momList_inner todo_list_inner Member_list_inner ">
            <div className="mom_header d-flex align-items-center justify-content-between mb-3">
              <h1 className="font_blue_18 font-600">{`Member List (${count})`}</h1>

              <ul className="d-flex align-items-center mom_filter">
                <li
                  className="d-flex align-items-center cursor-pointer"
                  onClick={() => setShow(true)}
                >
                  Filter By{" "}
                  <img
                    src="/images/Sort.svg"
                    className="img-fluid ms-2"
                    alt="Sort"
                  />
                </li>
                <li>
                  <button
                    className="btn red_button d-flex align-items-center"
                    onClick={() => navigate("/admin/add-members")}
                    disabled={!permissionscontext.add}
                  >
                    <FaPlus className="me-1" />
                    Add Member
                  </button>
                </li>
              </ul>
            </div>

            <div className="todoList_table">
              <div className="table-responsive">
                <Table>
                  <thead className="table-dark">
                    <tr>
                      <th>Sr.No</th>
                      <th>Name</th>
                      <th>Phone</th>
                      <th>Date</th>
                      <th>Role</th>
                      <th>Status</th>
                      <th>Manage</th>
                    </tr>
                  </thead>
                  {dataList && dataList?.length > 0 ? (
                    <>
                      <tbody>
                        {dataList &&
                          dataList?.map((item, index) => (
                            <tr key={item.id}>
                              <td>{(currentPage - 1) * limit + index + 1}</td>
                              <td>
                                <Link to={`/admin/member-details/${item.id}`}>
                                  <div className="d-flex align-items-center">

                                    {
                                      item?.profile_pic ?
                                        <img
                                          src={item.profile_pic}
                                          className="img-fluid me-2 table_user"
                                          alt={item.first_name}
                                          onError={(e) => (e.target.src = "/images/placeholder-img.jpg")}
                                        />
                                        :
                                        <img src="/images/placeholder-img.jpg"
                                          className='img-fluid me-2 table_user'
                                          alt="default img"
                                        />
                                    }
                                    <div>

                                      <h3 className="font_blue_16
                                      textTransform ">
                                        {item.fullname}
                                      </h3>
                                      <p className="font_blue_14">
                                        {item.email}
                                      </p>

                                    </div>
                                  </div>
                                </Link>
                              </td>
                              <td>
                                ({item?.country_code}) {item?.mobile}
                              </td>
                              <td>{formatDateTime(item.created)}</td>
                              <td>{item.role_name}</td>

                              <td>
                                <Form className="Switch_toggle">
                                  <input
                                    type="checkbox"
                                    id={`switch-${item.id}`}
                                    checked={item.status === "Active"}
                                    onClick={() => handleStatusChange(item)}
                                    disabled={!permissionscontext.edit}
                                  />
                                  <label
                                    className="position-relative"
                                    htmlFor={`switch-${item.id}`}
                                  >
                                    Toggle
                                  </label>
                                </Form>
                              </td>

                              <td>
                                <ul className="d-flex align-items-center justify-content-end gap-2">
                                  <li>
                                    <button
                                      disabled={!permissionscontext.view}
                                      style={{
                                        border: "none",
                                        background: "transparent",
                                        padding: 0,
                                        cursor: !permissionscontext.view
                                          ? "not-allowed"
                                          : "pointer",
                                        opacity: !permissionscontext.view
                                          ? 0.5
                                          : 1,
                                      }}
                                      onClick={() =>
                                        navigate(
                                          `/admin/member-details/${item.id}`
                                        )
                                      }
                                    >
                                      <img
                                        src="/images/Eye.svg"
                                        className={`img-fluid trash`}
                                        alt="eye"
                                      />
                                    </button>
                                  </li>
                                  <li>
                                    <button
                                      disabled={!permissionscontext.delete}
                                      style={{
                                        border: "none",
                                        background: "transparent",
                                        padding: 0,
                                        cursor: !permissionscontext.delete
                                          ? "not-allowed"
                                          : "pointer",
                                        opacity: !permissionscontext.delete
                                          ? 0.5
                                          : 1,
                                      }}
                                      onClick={() => {
                                        setSelectedId(item.id);
                                        setShowDt(true);
                                      }}
                                    >
                                      <img
                                        src="/images/Trash.svg"
                                        className={`img-fluid trash`}
                                        alt="trash"
                                      />
                                    </button>
                                  </li>
                                  <li>
                                    <button
                                      disabled={!permissionscontext.edit}
                                      style={{
                                        border: "none",
                                        background: "transparent",
                                        padding: 0,
                                        cursor: !permissionscontext.edit
                                          ? "not-allowed"
                                          : "pointer",
                                        opacity: !permissionscontext.edit
                                          ? 0.5
                                          : 1,
                                      }}
                                      onClick={() =>
                                        navigate(
                                          `/admin/update-members/${item.id}`,
                                          {
                                            state: { row: item },
                                          }
                                        )
                                      }
                                    >
                                      <img
                                        src="/images/Pen.svg"
                                        className={`img-fluid pen`}
                                        alt="pen"
                                      />
                                    </button>
                                  </li>
                                </ul>
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </>
                  ) : (
                    <>
                      <tbody>
                        <tr>
                          <td colSpan="6" className="border-0">
                            <div className="d-flex align-items-center justify-content-center mt-5">
                              <h4>Not Available</h4>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </>
                  )}
                </Table>
              </div>
            </div>
            {count > 10 && (

              <Paginator
                currentPage={currentPage}
                totalPages={totalCount}
                onPageChange={handlePageChange}
              />
            )}
          </div>
          <Offcanvas
            className="mom_filter"
            show={show}
            onHide={() => setShow(false)}
            placement="end"
          >
            <Offcanvas.Header closeButton>
              <Offcanvas.Title className="font_blue_18 font-600">
                Filter By
              </Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body className="pt-0">
              <Form className="filter_form">
                <div>
                  <label className="font_blue_14 font-500 mb-2">Name</label>
                  <Form.Control
                    type="text"
                    placeholder="Search Name..."
                    name="name"
                    value={searchTerm.name}
                    onChange={handleSearchChange}
                  />
                </div>
                <div>
                  <label className="font_blue_14 font-500 mb-2">
                    Email
                  </label>
                  <Form.Control
                    name="email"
                    placeholder="Enter Email"
                    value={searchTerm.email}
                    onChange={handleSearchChange}
                  >
                  </Form.Control>
                </div>
                <div>
                  <label className="font_blue_14 font-500 mb-2">
                    Mobile
                  </label>
                  <Form.Control
                    name="phone"
                    type="number"
                    placeholder="Enter Number"
                    value={searchTerm.phone}
                    onChange={handleSearchChange}
                  >
                  </Form.Control>
                </div>
                <div>
                  <label className="font_blue_14 font-500 mb-2">Role</label>
                  <Form.Select
                    name="role_id"
                    value={searchTerm.role_id}
                    onChange={handleSearchChange}
                  >
                    <option value="">Select Role</option>
                    {filterOptions?.roles?.map((item) => (
                      <option key={item.id} value={item.id}>
                        {capitalizeFirstLetter(item.name)}
                      </option>
                    ))}
                  </Form.Select>
                </div>
                <div>
                  <label className="font_blue_14 font-500 mb-2">Status</label>
                  <Form.Select
                    name="status"
                    value={searchTerm.status}
                    onChange={handleSearchChange}
                    aria-label="Select Status"
                  >
                    <option value="">Select Status</option>
                    <option value="Active">Active</option>
                    <option value="Inactive">Inactive</option>
                  </Form.Select>
                </div>


                <div>
                  <label className="font_blue_14 font-500 mb-2">Region</label>
                  <Form.Select
                    name="region_id"
                    value={searchTerm.region_id}
                    onChange={handleSearchChange}
                  >
                    <option value="">Select Region</option>
                    {filterOptions?.regions?.map((region) => (
                      <option key={region.id} value={region.id}>
                        {capitalizeFirstLetter(region.name)}
                      </option>
                    ))}
                  </Form.Select>
                </div>

                <div>
                  <label className="font_blue_14 font-500 mb-2">State</label>
                  <Form.Select
                    name="state_id"
                    value={searchTerm.state_id}
                    onChange={handleSearchChange}
                  >
                    <option value="">Select State</option>
                    {filterOptions?.states?.map((state) => (
                      <option key={state.id} value={state.id}>
                        {capitalizeFirstLetter(state.name)}
                      </option>
                    ))}
                  </Form.Select>
                </div>

                <div>
                  <label className="font_blue_14 font-500 mb-2">City</label>
                  <Form.Select
                    name="city_id"
                    value={searchTerm.city_id}
                    onChange={handleSearchChange}
                  >
                    <option value="">Select City</option>
                    {filterOptions?.cities?.map((city) => (
                      <option key={city.id} value={city.id}>
                        {capitalizeFirstLetter(city.name)}
                      </option>
                    ))}
                  </Form.Select>
                </div>
              </Form>
            </Offcanvas.Body>

            <div className="offcanvas-footer">
              <button
                className="btn blue_border"
                onClick={() => {
                  resetDta();
                  setFlag(true);
                }}
              >
                Clear
              </button>
              <button className="btn red_button" onClick={() => fetchData()}>
                Apply
              </button>
            </div>
          </Offcanvas>
          <DeleteModal
            showdt={showDt}
            handleCloseDt={() => setShowDt(false)}
            handledelete={handleDelete}
          />
          <ToastContainer />
        </>
      ) : (
        <Notauthorized />
      )}
    </>
  );
};

export default MemberList;
